import { render, staticRenderFns } from "./flexLayout.vue?vue&type=template&id=40e6288d&"
import script from "./flexLayout.vue?vue&type=script&lang=js&"
export * from "./flexLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports